import {
  type HealthNotifications,
  HealthNotificationsSchema,
  type ContentActivity,
  type ContentActivityQuery,
  ContentActivitySchema,
  type AcknowledgeIssuesRequest,
  type ActivityFacets,
  type ActivityFacetsQuery,
  ActivityFacetsSchema,
  type ActivityPage,
  ActivityPageSchema,
  type ActivityQuery,
  apiPath,
  type HealthIssuesPage,
  HealthIssuesPageSchema,
  type HealthIssuesQuery,
  type HealthSettings,
  HealthSettingsSchema,
  type HealthSummary,
  HealthSummarySchema,
  type PlaybackHealth,
  PlaybackHealthSchema,
} from '@codot/contracts';
import { request } from './http';

const qs = (params: Record<string, unknown>) => {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    p.set(k, Array.isArray(v) ? v.join(',') : String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : '';
};

/** Phase 16 Step 13: Health Check. */
export const healthApi = {
  issues: (q: HealthIssuesQuery): Promise<HealthIssuesPage> => request('GET', `${apiPath('healthIssues')}${qs(q)}`, HealthIssuesPageSchema),
  summary: (): Promise<HealthSummary> => request('GET', apiPath('healthSummary'), HealthSummarySchema),
  playback: (): Promise<PlaybackHealth> => request('GET', apiPath('healthPlayback'), PlaybackHealthSchema),
  acknowledge: (body: AcknowledgeIssuesRequest): Promise<unknown> => request('POST', apiPath('healthAcknowledge'), null, body),
  recheck: (): Promise<HealthSummary> => request('POST', apiPath('healthRecheck'), HealthSummarySchema),
  settings: (): Promise<HealthSettings> => request('GET', apiPath('healthSettings'), HealthSettingsSchema),
  setSettings: (body: HealthSettings): Promise<HealthSettings> => request('PUT', apiPath('healthSettings'), HealthSettingsSchema, body),
  /** Phase 17.12: the notification bell. */
  notifications: (): Promise<HealthNotifications> => request('GET', apiPath('healthNotifications'), HealthNotificationsSchema),
  markSeen: (): Promise<unknown> => request('POST', apiPath('healthNotificationsSeen'), null),
};

/** Phase 16 Step 13: Activity Log (Audit is ADMIN+). */
export const activityApi = {
  list: (q: ActivityQuery): Promise<ActivityPage> => request('GET', `${apiPath('activity')}${qs(q)}`, ActivityPageSchema),
  /** A same-origin link: the browser downloads the streamed CSV with the session cookie. */
  exportUrl: (q: Omit<ActivityQuery, 'cursor' | 'limit'>): string => `${apiPath('activityExport')}${qs(q)}`,
  /** What the event type / who / item filters can offer for a period. */
  facets: (q: ActivityFacetsQuery): Promise<ActivityFacets> => request('GET', `${apiPath('activityFacets')}${qs(q)}`, ActivityFacetsSchema),
  /** One content item's owner and history (content Information Panel). */
  content: (q: ContentActivityQuery): Promise<ContentActivity> => request('GET', `${apiPath('contentActivity')}${qs(q)}`, ContentActivitySchema),
};
